import React, { lazy, Suspense } from 'react';
import { render } from "react-dom";

const Mileage = lazy(() => import(/* webpackChunkName: "Mileage" */ './components/Mileage'));

const mileageNodes = Array.from(document.querySelectorAll(".extranet-mileage"));
if (mileageNodes != null) {
    mileageNodes.forEach(node => {
        const vehicleMileage =
            typeof node.dataset.vehicleMileage !== "undefined" ? node.dataset.vehicleMileage : '';

        const updateUrl =
            typeof node.dataset.updateUrl !== "undefined" ? node.dataset.updateUrl : '';

        render(
            <Suspense fallback={<></>}>
                <Mileage updateUrl={updateUrl} vehicleMileage={vehicleMileage} />
            </Suspense>,
            node
        );
    });
}
